import { Colors, Media } from 'enums';
import styled from 'styled-components';

export const ModalFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  @media ${Media.notebook} {
    gap: 40px;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media ${Media.notebook} {
    gap: 24px;
  }

  input {
    background-color: ${Colors.gray5};
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: center;

  @media ${Media.notebook} {
    gap: 16px;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media ${Media.notebook} {
    gap: 12px;
  }
`;
